export default __webpack_public_path__ + "static/media/tools.c9f098df.svg";